var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-container pt-5"},[_c('div',{staticClass:"carder mb-5",attrs:{"id":"mapid"}})])}]

export { render, staticRenderFns }